import type { GlobalFieldReference } from '@ps/web-martech-cms-types';
import type { ContainerBlock, Main } from '@ps/web-martech-cms-types/Main';
import React from 'react';

import CMSContainer from '../CMSContainer/CMSContainer';
import CMSReference from '../CMSReference/CMSReference';
import CMSReferences from '../CMSReference/CMSReferences';

const CMSMain: React.FC<Main> = ({ body }) => (
  <>
    {body.map((item, index) => {
      const [[type, value]] = Object.entries(item);
      if (type === 'container') {
        return <CMSContainer key={index} {...(item as ContainerBlock)} />;
      }
      if (['feed', 'refer_a_friend'].includes(type) || type.endsWith('widget')) {
        return <CMSReferences key={index} references={value.reference} />;
      }
      return <CMSReference key={index} {...(item as GlobalFieldReference)} />;
    })}
  </>
);

export default CMSMain;
